import React from "react";

const TESTIMONIAL_IMAGES = [
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/3uietm76_Screenshot%202026-06-02%20at%2012.09.01.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/0szgj2dz_Screenshot%202026-06-02%20at%2012.09.41.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/epnrvol7_Screenshot%202026-06-02%20at%2013.32.35.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/qo64qn5z_Screenshot%202026-06-02%20at%2012.10.35.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/2wv229ee_Screenshot%202026-06-02%20at%2012.11.03.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/3s4cub2i_Screenshot%202026-06-02%20at%2012.11.52.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/v8wecbnm_Screenshot%202026-06-02%20at%2012.12.19.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/8bro6jeq_Screenshot%202026-06-02%20at%2013.29.11.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/pp6vpm2z_Screenshot%202026-06-02%20at%2013.30.15.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/3hdb59jq_Screenshot%202026-06-02%20at%2013.31.01.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/l9jx6swm_Screenshot%202026-06-02%20at%2013.31.29.png",
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/o36hnl5j_Screenshot%202026-06-02%20at%2013.32.03.png",
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-center text-4xl md:text-5xl font-extrabold text-navy mb-14">
          Artist Talk
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {TESTIMONIAL_IMAGES.map((src) => (
            <div
              key={src}
              className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow overflow-hidden"
            >
              <img
                src={src}
                alt="Artist testimonial"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
